import { render, staticRenderFns } from "./SmTextHyperlinked.vue?vue&type=template&id=48d14af6&scoped=true&"
import script from "./SmTextHyperlinked.vue?vue&type=script&lang=ts&"
export * from "./SmTextHyperlinked.vue?vue&type=script&lang=ts&"
import style0 from "./SmTextHyperlinked.vue?vue&type=style&index=0&id=48d14af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d14af6",
  null
  
)

export default component.exports